import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { DYNAMIC_TASKS_CONFIG, TASKS_CONFIGS } from '../../../../constants';
import type { Task } from '../../../../types';

export function useDescription() {
	const { translate } = useI18n();

	return useCallback(
		({ name, metadata }: { name: Task['name']; metadata: Task['metadata'] }) => {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const key = name as keyof typeof TASKS_CONFIGS;
			const { description } = TASKS_CONFIGS[key];

			switch (name) {
				case 'share_top_starter_share_channel': {
					// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
					const translationKey = DYNAMIC_TASKS_CONFIG.share_top_starter_share_channel.channel[metadata.channel];
					const translatedChannel = translate(translationKey);
					return translate(description, {
						channel: translatedChannel,
					});
				}
				default: {
					return translate(description);
				}
			}
		},
		[translate],
	);
}
